<template>
  <div class="layer-panel">
    <div class="panel__header">
      <div class="title">第{{ layerData.layer }}层</div>
      <div class="extra">
        <div v-if="layerData.layer !== 1" class="side-input">
          <el-radio-group v-model="layerData.sideCount">
            <el-radio-button label="1">1面</el-radio-button>
            <el-radio-button label="2">2面</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="panel__body">
      <div class="sides-wrapper">
        <template v-for="(it, index) in visibleSides" :key="`s_${it.code}`">
          <div v-if="index < (layerData.sideCount || 1)" class="side-item" :style="{ flex: it.span || 1 }">
            <side-panel :side-data="it" :layer-number="currentLayerNumber" :disabled="disabled" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from '@zto/zpage'

import SidePanel from './side-panel.vue'

const props = defineProps<{
  layerData: any
  disabled: boolean
}>()

const currentLayerNumber = computed(() => {
  return props.layerData.layer
})

const visibleSides = computed(() => {
  const sides = (props.layerData.sides || []).filter((it: any) => it.visible !== false)
  return sides
})
</script>

<style lang="scss" scoped>
.layer-panel {
  .panel {
    &__header {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      background-color: #fafafa;
      border-bottom: 1px solid #f0f0f0;

      .title {
        flex: 1;
      }

      .extra {
        display: flex;
        align-items: center;
      }
    }
  }
}

.sides-wrapper {
  display: flex;
  gap: 5px;

  padding: 10px;
  box-sizing: border-box;
}
</style>
